import React, { useEffect, useState } from 'react';
import { FournisseurService } from '../../../../services/FournisseurService';
import { Form, Spinner, Card, Tabs, Table, Tab, Row, Col, Accordion, Button, OverlayTrigger, Alert, Tooltip, Dropdown, Badge } from 'react-bootstrap';
import { useAccordionButton } from 'react-bootstrap/AccordionButton';
import ErrorManager from "../../../error-manager/ErrorManager";
import { getFormErrorMsg } from '../../../../helper/Helper'
//import './FournisseurDetails.scss';
import TextArrayInput from "../../../form-inputs/text-array-input/TextArrayInput";
import { ProformaService } from '../../../../services/ProformaService';
import { reorder, sortByNumber, currencyFormat, deepFind } from '../../../../helper/Helper'
import MdReader from '../../../../components/md-reader/MdReader';
import './ProformaDetails.scss';
import { GlobalContext } from "../../../../services/GlobalProvider";
import Split from '../../../../components/split/Split';


const ProformaDetails = (props) => {

    const [proforma, setProforma] = useState()
    const [getProformaLoading, setGetProformaLoading] = useState()
    let [openElement, setOpenElement] = useState("infos")

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);

    useEffect(() => {
        getProforma()
        setOpenElement("infos")
    }, [props.proformaId]);

    function handleTabSelect(key) {
        setOpenElement(key)
    }

    function getProforma() {
        setGetProformaLoading(true)

        ProformaService.getProforma(props.folderId, props.proformaId).then(res => {

            sortByNumber(res.data.data.details, "numero_ligne")

            setProforma(res.data.data)
            setGetProformaLoading(false)

        }).catch(error => {
            setGetProformaLoading(false)

            // setIsGetProformasLoading(false)
            // setGlobalError(error)
        });
    }

    return (

        <div id="ProformaDetails">

            {(!proforma && getProformaLoading) &&
                <span className="hloader mt-3"></span>
            }

            {(proforma && !getProformaLoading) &&
                <>
                    <div className="d-flex mb-4">
                        <div className="me-auto">
                            <div className="me-3">
                                <h6 className="m-0">{proforma.client_nom}</h6>
                            </div>
                            <div className="me-3">
                                <Badge bg="light" text="dark" className="me-2">Type : {proforma.type}</Badge>
                                <Badge bg="light" text="dark" className="me-2">Date : {new Date(proforma.date).toLocaleString()}</Badge>

                                {(proforma?.validite_etat_calc == "expiree") &&
                                    <Badge bg="warning" className="text-dark">Expirée</Badge>
                                }
                                {(proforma?.validite_etat_calc == "annulee") &&
                                    <Badge bg="danger">Annulée</Badge>
                                }
                                {(proforma?.validite_etat_calc == "facturee") &&
                                    <Badge bg="primary-500">Facturée</Badge>
                                }
                                {(proforma?.validite_etat_calc == "encours") &&
                                    <Badge bg="success">En cours</Badge>
                                }

                            </div>
                        </div>



                        {props.elementActions.length > 0 &&
                            <Dropdown className="float-end ms-2 me-3">
                                <OverlayTrigger
                                    placement="left"
                                    delay={{ show: 800 }}
                                    overlay={
                                        <Tooltip>
                                            Plus d'actions
                                        </Tooltip>
                                    }
                                >
                                    <Dropdown.Toggle variant="secondary" className='no-btn-caret'>
                                        <i className="material-icons i-lg">more_horiz</i>
                                    </Dropdown.Toggle>
                                </OverlayTrigger>
                                <Dropdown.Menu>
                                    {props.elementActions.map((element, i) => {
                                        // Cache le bouton d'action si une condition est présente dans "disableKeyValues"
                                        let visible = true
                                        element?.disableKeyValues && Object.keys(element.disableKeyValues)?.map((key, index) => {
                                            element.disableKeyValues[key].indexOf(deepFind(proforma, key)) > -1 && (
                                                visible = false
                                            )
                                        })
                                        if (visible) {
                                            return (
                                                <Dropdown.Item key={element.title} onClick={() => props.setElementAction(element.action, proforma)}>{element.title}</Dropdown.Item>
                                            )
                                        }
                                    })}
                                </Dropdown.Menu>
                            </Dropdown>
                        }
                    </div>

                    <div className="">
                        <Tabs variant="pills" defaultActiveKey="infos" onSelect={handleTabSelect} className="mb-3">

                            <Tab eventKey="infos" title="Infos" className="light-v-scroll height-full-min-250 pe-2">
                                {openElement == "infos" &&



                                    <Accordion defaultActiveKey={['description', 'proforma', 'details', 'observations', 'client']} alwaysOpen>

                                        <Accordion.Item eventKey="description" className="border-0 mb-3 text-break">
                                            <Accordion.Header>Description</Accordion.Header>
                                            <Accordion.Body className="px-1">
                                                {proforma.description &&
                                                    <p>{proforma.description}</p>
                                                }
                                                {!proforma.description &&
                                                    <em>- Aucune description rédigée -</em>
                                                }
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="client" className="border-0 mb-3">
                                            <Accordion.Header>Client</Accordion.Header>
                                            <Accordion.Body className="px-1">
                                                {proforma.client._id && <Split title="Client" border value={<a href={`/${props.folderId}/clients?clientId=${proforma.client._id}`} target="_blank">Afficher le client</a>} />}
                                                <Split border title="Nom" value={proforma.client.nom} />
                                                <Split border title="Code" value={proforma.client.code} />
                                                <Split border title="Profession" value={proforma.client.profession} />
                                                <Split title="Bloquer" value={proforma.client.bloquer ? "Oui" : "Non"} />
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="proforma" className="border-0 mb-3">
                                            {proforma.type == "proforma" &&
                                                <Accordion.Header>Proforma</Accordion.Header>
                                            }
                                            {proforma.type == "avoir" &&
                                                <Accordion.Header>Avoir</Accordion.Header>
                                            }
                                            <Accordion.Body className="px-1">
                                                <Split border title="Code" value={proforma.code} />
                                                <Split border title="Utilisateur" value={proforma.user} />
                                                <Split border title="Vendeur" value={proforma.vendeur} />
                                                <Split border title="Mention exonération" value={proforma.mention_calc?.exoneration} />
                                                <Split border title="Mention historique" value={proforma.mention_calc?.historique} />
                                                {parametres?.general?.export_comptable.comptabilite_analytique &&
                                                    <Split border title="Secteur analytique" value={proforma.secteur_analytique} />
                                                }
                                                <Split border title={`Total prix revient (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_prix_revient)} />
                                                <Split border title={`Total brut hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_brut_ht)} />
                                                <Split border title={`Total net hors taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_net_ht)} />
                                                <Split border title={`Total remise (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_remise)} />
                                                <Split border title={`Total TTC (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_ttc)} />
                                                <Split border title="Statut" value={proforma.statut} />
                                                <Split title={`Total montant taxes (${parametres?.general?.devise_dossier})`} value={currencyFormat(proforma.total_taxes?.montant_total)} />
                                                <div className="">
                                                    {proforma.total_taxes?.montants_details.map(montant => (
                                                        <Badge key={montant.contribution_id} bg="gray-200" text="dark" className="me-2">{montant.libelle}</Badge>
                                                    ))}
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="details" className="border-0 mb-3">
                                            <Accordion.Header>Details</Accordion.Header>
                                            <Accordion.Body className="px-1 overflow-auto bg-gray-100">

                                                {/* {(proforma.details.length > 0) &&
                                                    <>
                                                        {proforma.details.map(d =>
                                                            <div className="py-2">
                                                                {d.code &&
                                                                    <span className="me-2">{d.code}</span>
                                                                }
                                                                {d.designation &&
                                                                    <>
                                                                        {d.article_id &&
                                                                            <span><a href={`/${props.folderId}/articles/?articleId=${d.article_id}`}>{d.designation}</a></span>
                                                                        }
                                                                        {!d.article_id &&
                                                                            <span>{d.designation}</span>
                                                                        }
                                                                    </>
                                                                }
                                                                <div className="w-100">
                                                                    {d.quantite &&
                                                                        <span className="bg-gray-100 rounded px-2 me-1 mb-1 small text-gray-600">
                                                                            Qté : <b>{d.quantite}</b>
                                                                        </span>
                                                                    }
                                                                    {d.prix_vente_ht &&
                                                                        <span className="bg-gray-100 rounded px-2 me-1 mb-1 small text-gray-600">
                                                                            Prix unit. HT : <b>{d.prix_vente_ht}</b>
                                                                        </span>
                                                                    }
                                                                    {d.remise?.taux &&
                                                                        <span className="bg-gray-100 rounded px-2 me-1 mb-1 small text-gray-600">
                                                                            Remise : <b>{d.remise?.taux}</b>
                                                                        </span>
                                                                    }
                                                                </div>


                                                            </div>
                                                        )}
                                                    </>

                                                } */}

                                                {(proforma.details.length > 0) &&
                                                    <div className="table-container mt-2">
                                                        <Table borderless className="small w-100">
                                                            <thead>
                                                                <tr className='text-gray-600 text-uppercase'>
                                                                    <th>Code</th>
                                                                    <th style={{ minWidth: 220 }}>Désignation</th>
                                                                    <th>Qté</th>
                                                                    <th>Prix H.T</th>
                                                                    <th>Montant H.T</th>
                                                                    <th>Taux remise</th>
                                                                    <th>Montant remise</th>
                                                                    <th>Taux contrib.</th>
                                                                    <th>Montant contri.</th>
                                                                    <th>Px. de revient</th>
                                                                    <th>Px. de vente TTC</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody className="align-middle">
                                                                {proforma.details.map(d =>
                                                                    <tr key={d._id}>
                                                                        <td>{d.code}</td>
                                                                        <td>
                                                                            {d.article_id && <a href={`/${props.folderId}/articles/?articleId=${d.article_id}`}>{d.designation}</a>}
                                                                            {!d.article_id && <span>{d.designation}</span>}
                                                                        </td>
                                                                        <td>{d.quantite}</td>
                                                                        <td>{currencyFormat(d.prix_vente_ht)}</td>
                                                                        <td>{currencyFormat(d.montant_net_ht)}</td>
                                                                        <td>{d.remise?.taux}</td>
                                                                        <td>{d.remise?.montant}</td>
                                                                        <td>
                                                                            {d.contributions?.map(c => (
                                                                                <span key={c.contribution_id} className="rounded bg-gray-300 px-1 me-1">
                                                                                    {c.valeur}
                                                                                </span>
                                                                            ))}
                                                                        </td>
                                                                        <td>
                                                                            {d.contributions?.map(c => (
                                                                                <span key={c.contribution_id} className="rounded bg-gray-300 px-1 me-1">
                                                                                    {currencyFormat(c.montant)}
                                                                                </span>
                                                                            ))}
                                                                        </td>
                                                                        <td>{currencyFormat(d.prix_revient)}</td>
                                                                        <td>{currencyFormat(d.montant_ttc)}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </Table>
                                                    </div>
                                                }
                                                {(proforma.details.length == 0) &&
                                                    <em>- Aucune ligne de détail n'a été saisie -</em>
                                                }
                                            </Accordion.Body>
                                        </Accordion.Item>

                                        <Accordion.Item eventKey="observations" className="border-0 mb-3">
                                            <Accordion.Header>Observations</Accordion.Header>
                                            <Accordion.Body className="px-1">
                                                {proforma.observation &&
                                                    <MdReader mdData={proforma.observation} />
                                                }
                                            </Accordion.Body>
                                        </Accordion.Item>

                                    </Accordion>
                                }
                            </Tab>

                            <Tab eventKey="corrige" title="Documents liés" className="light-v-scroll height-full-min-250 pe-2">

                                {(proforma.historiques?.precedents?.filter(document => document._id !== proforma?._id).length == 0) && (proforma.historiques?.suivants?.filter(document => document._id !== proforma?._id).length == 0) ?
                                    <em>- Aucun document lié -</em>
                                    :
                                    <span className="d-flex flex-column border-start border-gray-400 ps-3">
                                        {proforma.historiques?.precedents?.filter(document => document._id !== proforma?._id)?.map((document, i) => (
                                            <div key={i}>
                                                {document.type == "avoir" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/factures/?factureId=${document._id}`}>Avoir {document.code}</a>
                                                }
                                                {document.type == "abonnement" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/abonnements/?abonnementId=${document._id}`}>Abonnement {document.code}</a>
                                                }
                                                {document.type == "proforma" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/proformas/?proformaId=${document._id}`}>Proforma {document.code}</a>
                                                }
                                                {document.type == "facture" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/factures/?factureId=${document._id}`}>Facture {document.code}</a>
                                                }
                                            </div>
                                        ))}
                                        {((proforma.historiques?.precedents?.length > 0) || (proforma.historiques?.suivants?.length > 0)) &&
                                            <p className="time-dot my-2">Document actuel ({proforma.type} {proforma.code})</p>
                                        }
                                        {proforma.historiques?.suivants?.map((document, i) => (
                                            <div key={i}>
                                                {document.type == "avoir" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/factures/?factureId=${document._id}`}>Avoir {document.code}</a>
                                                }
                                                {document.type == "abonnement" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/abonnements/?abonnementId=${document._id}`}>Abonnement {document.code}</a>
                                                }
                                                {document.type == "proforma" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/proformas/?proformaId=${document._id}`}>Proforma {document.code}</a>
                                                }
                                                {document.type == "facture" &&
                                                    <a className="time-dot my-2" href={`/${props.folderId}/factures/?factureId=${document._id}`}>Facture {document.code}</a>
                                                }
                                            </div>
                                        ))}
                                    </span>
                                }
                            </Tab>


                        </Tabs>
                    </div>



                </>
            }
        </div>
    )

}

export default ProformaDetails;

